import React, { useState, useEffect } from "react";
import moment from "moment";
import ReactTooltip from "react-tooltip";

import Tabs from "../../../components/Rewards/Tabs";
import { newFetch, GET } from "../../../helpers/fetch";

const TransactionHistory = () => {
  const associate_id = JSON.parse(localStorage.getItem("user")).id;
  const tabs = ["Available", "Expired"];
  const [activeTab, setActiveTab] = useState("Available");
  const [pointsLifeCycle, setPoinstLifeCycle] = useState(null);
  const [TransactionHistory, setTransactionHistory] = useState([]);
  const [available, setAvailable] = useState([]);
  const [expired, setExpired] = useState([]);
  const [newEarnedPoints, setNewEarnedPoints] = useState([]);

  const fetchTransactionHistory = async () => {
    let api_path = `/reward/history_transaction/${associate_id}`;
    let response = await newFetch(GET, api_path);

    if (response.success) setTransactionHistory(response.results);
  };

  const fetchSetting = async () => {
    let api_path = `/reward/setting`;
    let response = await newFetch(GET, api_path);

    if (response.success) setPoinstLifeCycle(response.data.points_life_cycle);
  };

  useEffect(() => {
    if (TransactionHistory) {
      setNewEarnedPoints(
        TransactionHistory.filter(
          (history) => history.reward_earned_points.length > 0
        )
      );
    }
  }, [TransactionHistory]);

  // useEffect(() => {
  //   if (TransactionHistory && pointsLifeCycle) {
  //     let availableData = TransactionHistory.filter(history =>
  //       moment().isSameOrBefore(
  //         moment(history.createdAt).add(pointsLifeCycle, 'M')
  //       )
  //     ).sort((a, b) =>
  //       moment(a.createdAt).isBefore(moment(b.createdAt)) ? 1 : -1
  //     )
  //     let expiredData = TransactionHistory.filter(history =>
  //       moment().isAfter(moment(history.createdAt).add(pointsLifeCycle, 'M'))
  //     ).sort((a, b) =>
  //       moment(a.createdAt).isAfter(moment(b.createdAt)) ? 1 : -1
  //     )
  //     setAvailable(
  //       availableData.map(history => ({
  //         ...history,
  //         expiry_date: moment(history.createdAt).add(pointsLifeCycle, 'M')
  //       }))
  //     )
  //     setExpired(expiredData)
  //   }
  // }, [TransactionHistory, pointsLifeCycle])

  useEffect(() => {
    if (newEarnedPoints) {
      let availableData = newEarnedPoints
        .filter(
          (history) =>
            history.reward_earned_points[0]?.expiry_date === null ||
            moment().isSameOrBefore(
              moment(history.reward_earned_points[0]?.expiry_date)
            )
        )
        .sort((a, b) =>
          moment(a.reward_earned_points[0]?.expiry_date).isBefore(
            moment(b.reward_earned_points[0]?.expiry_date)
          )
            ? 1
            : -1
        );

      let expiredData = newEarnedPoints
        .filter((history) =>
          moment().isAfter(moment(history.reward_earned_points[0]?.expiry_date))
        )
        .sort((a, b) =>
          moment(a.reward_earned_points[0]?.expiry_date).isAfter(
            moment(b.reward_earned_points[0]?.expiry_date)
          )
            ? 1
            : -1
        );

      setAvailable(
        availableData.map((history) => ({
          ...history,
          expiry_date:
            history.reward_earned_points[0]?.expiry_date === null
              ? null
              : moment(history.reward_earned_points[0]?.expiry_date),
        }))
      );

      setExpired(expiredData);
    }
  }, [newEarnedPoints]);

  useEffect(() => {
    fetchSetting();
    fetchTransactionHistory();
  }, []);

  return (
    <>
      <div className="container d-flex flex-column">
        <Tabs
          tabs={tabs}
          activeTab={activeTab}
          handleToggleTab={setActiveTab}
        />
        {activeTab === "Available" &&
          available.length > 0 &&
          available.map((history, index) => (
            <div
              key={history.id}
              className="py-2 px-3 mb-2 border rounded d-flex justify-content-between align-items-center"
            >
              <div className="d-flex flex-column">
                <h3>{history.points}</h3>
                <small>POINTS</small>
              </div>
              <div className="d-flex flex-column flex-grow-1 pl-3">
                <div className="d-flex mb-3 justify-content-between align-items-center">
                  <strong>{history.reason.reason}</strong>
                  {history.remarks && (
                    <>
                      <i
                        className="fas fa-info-circle text-brand"
                        data-tip
                        data-event="click focus"
                        data-for={`history-${index}`}
                      ></i>
                      <ReactTooltip
                        className="overrideMe"
                        multiline={true}
                        place="left"
                        id={`history-${index}`}
                      >
                        <span>{history.remarks}</span>
                      </ReactTooltip>
                    </>
                  )}
                </div>
                <small className="text-muted">
                  Used Points:{" "}
                  {history.transactions
                    ? history.transactions[0].used_points
                    : null}
                </small>

                {history.expiry_date === null ? (
                  <small className="text-muted">Credit rewards no expiry</small>
                ) : (
                  <small className="text-muted">
                    EXP: {moment(history.expiry_date).format("D MMMM YYYY")}
                  </small>
                )}
              </div>
            </div>
          ))}
        {activeTab === "Expired" &&
          available.length > 0 &&
          expired.map((history, index) => (
            <div
              key={history.id}
              className="py-2 px-3 mb-2 border rounded d-flex justify-content-between align-items-center"
            >
              <div className="d-flex flex-column">
                <h3>{history.points}</h3>
                <small>POINTS</small>
              </div>
              <div className="d-flex flex-column flex-grow-1 pl-3">
                <div className="d-flex mb-3 justify-content-between align-items-center">
                  <strong>{history.reason.reason}</strong>
                  {history.remarks && (
                    <>
                      <i
                        className="fas fa-info-circle text-brand"
                        data-tip
                        data-event="click focus"
                        data-for={`history-${index}`}
                      ></i>
                      <ReactTooltip
                        className="overrideMe"
                        place="left"
                        id={`history-${index}`}
                      >
                        <span>{history.remarks}</span>
                      </ReactTooltip>
                    </>
                  )}
                </div>
                <small className="text-muted">Expired</small>
              </div>
            </div>
          ))}
      </div>
    </>
  );
};

export default TransactionHistory;
